var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-page-container",class:{ 'full-page': _vm.isFullPage }},[(_vm.isLoading)?_c('loading-spinner'):(_vm.successLoading)?_c('success-loading'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }